export const KEYS_RESPONSES: Record<string, string> = {
  PICTURE: 'picture',
  ACHIEVEMENT: 'achievement',
  PERSONAL_ID: 'personal_id',
  TRIBUTARIO_ID: 'tributario_id',
}